"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeMarginLiquidationEvents = exports.subscribeMarginCallEvents = exports.subscribeMarginAccountBalanceSummaryStateEvents = exports.subscribeMarginAccountBalanceStateEvents = exports.requestMarginInstruments = exports.requestMarginAccount = exports.refreshMarginAccountInfo = exports.receiveSystemMarginEnabled = exports.receiveMarginKVPInfo = exports.receiveMarginInstruments = exports.receiveMarginAccountInfo = exports.preloadMarginData = exports.initMarginTrading = exports.getMaxTransferAmount = exports.getMarginProductsConfig = exports.getMarginKVP = exports.getMarginInstruments = exports.getMarginAccountInfo = exports.getInstrumentVerificationLevelConfig = exports.getAccountMarginBalances = exports.dismissMarginNotification = void 0;
var _apiActions = require("../../actions/apiActions");
var _snackbarActions = require("../../actions/snackbarActions");
var _userActions = require("../../actions/userActions");
var _selectors = require("../selectors");
var _marginHistoryActions = require("./marginHistoryActions");
var _MarginCallSubscriptionService = _interopRequireDefault(require("../services/MarginCallSubscriptionService"));
var _MarginAccountLiquidationSubscriptionService = _interopRequireDefault(require("../services/MarginAccountLiquidationSubscriptionService.js"));
var _MarginAccountBalanceSummaryStateSubscriptionService = _interopRequireDefault(require("../services/MarginAccountBalanceSummaryStateSubscriptionService.js"));
var _MarginAccountBalanceStateSubscriptionService = _interopRequireDefault(require("../services/MarginAccountBalanceStateSubscriptionService.js"));
var _orderHistoryActions = require("../../actions/orderHistoryActions");
var _marginNavNotificationActions = require("./marginNavNotificationActions.js");
var _marginNotificationsReducer = require("../reducers/marginNotificationsReducer");
var _actionTypes = require("../actionTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var preloadMarginData = exports.preloadMarginData = function preloadMarginData(AccountId, OMSId) {
  return function (dispatch) {
    dispatch(getMarginAccountInfo(AccountId, OMSId));
    dispatch((0, _orderHistoryActions.getOpenOrders)(AccountId, OMSId));
    dispatch((0, _marginHistoryActions.getOpenPositions)(AccountId, OMSId));
    dispatch((0, _marginHistoryActions.getClosedPositions)(AccountId, OMSId));
    dispatch((0, _marginHistoryActions.subscribeToMarginPositionEvents)(AccountId));
    dispatch(subscribeMarginCallEvents(AccountId));
    dispatch(subscribeMarginLiquidationEvents(AccountId));
    dispatch(subscribeMarginAccountBalanceSummaryStateEvents(AccountId));
    dispatch(subscribeMarginAccountBalanceStateEvents(AccountId));
    dispatch(getAccountMarginBalances(AccountId));
    dispatch(getInstrumentVerificationLevelConfig(OMSId, AccountId));
  };
};

// Margin - 8.25.23
var requestMarginAccount = exports.requestMarginAccount = function requestMarginAccount() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var UserId, responseObj, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            UserId = getState().user.userInfo.UserId;
            _context.p = 1;
            _context.n = 2;
            return dispatch((0, _apiActions.callAPI)('RequestMarginAccount', {}));
          case 2:
            responseObj = _context.v;
            if (!(responseObj && responseObj.result == false)) {
              _context.n = 3;
              break;
            }
            dispatch((0, _snackbarActions.showSnack)({
              id: 'requestMarginAccountError',
              text: responseObj.errormsg,
              type: 'warning'
            }));
            return _context.a(2, false);
          case 3:
            dispatch((0, _userActions.getUserInfo)(UserId));
            return _context.a(2, true);
          case 4:
            _context.n = 6;
            break;
          case 5:
            _context.p = 5;
            _t = _context.v;
            console.error('requestMarginAccountError error: ', _t);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'requestMarginAccountError',
              text: _t.o,
              type: 'warning'
            }));
            return _context.a(2, false);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[1, 5]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getMarginInstruments = exports.getMarginInstruments = function getMarginInstruments(OMSId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var instruments, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            dispatch(requestMarginInstruments());
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetAllMarginInstrumentConfigs', {
              OMSId: OMSId
            }));
          case 1:
            instruments = _context2.v;
            dispatch(receiveMarginInstruments(instruments));
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            console.error('GetMarginInstruments error: ', _t2);
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var requestMarginInstruments = exports.requestMarginInstruments = function requestMarginInstruments() {
  return {
    type: _actionTypes.REQUEST_MARGIN_INSTRUMENTS
  };
};
var receiveMarginInstruments = exports.receiveMarginInstruments = function receiveMarginInstruments(instruments) {
  return {
    type: _actionTypes.RECEIVE_MARGIN_INSTRUMENTS,
    payload: instruments
  };
};
var getAccountMarginBalances = exports.getAccountMarginBalances = function getAccountMarginBalances(AccountId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var OMSId, HideSmallAmounts, responseObj, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            HideSmallAmounts = localStorage.getItem('hideMarginSmallAmounts') !== 'false';
            _context3.p = 1;
            dispatch({
              type: _actionTypes.REQUEST_MARGIN_BALANCES
            });
            _context3.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetAccountMarginBalances', {
              OMSId: OMSId,
              AccountId: AccountId,
              HideSmallAmounts: HideSmallAmounts
            }));
          case 2:
            responseObj = _context3.v;
            if (!responseObj) {
              _context3.n = 3;
              break;
            }
            dispatch({
              type: _actionTypes.RECEIVE_MARGIN_BALANCES,
              payload: responseObj
            });
            return _context3.a(2, true);
          case 3:
            dispatch((0, _snackbarActions.showSnack)({
              id: 'GetAccountMarginBalancesError',
              text: 'Get Account Margin Balances Error.',
              type: 'warning'
            }));
            return _context3.a(2, false);
          case 4:
            _context3.n = 6;
            break;
          case 5:
            _context3.p = 5;
            _t3 = _context3.v;
            console.error('GetAccountMarginBalancesError error: ', _t3);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'GetAccountMarginBalancesError',
              text: _t3.o,
              type: 'warning'
            }));
            return _context3.a(2, false);
          case 6:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 5]]);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var refreshMarginAccountInfo = exports.refreshMarginAccountInfo = function refreshMarginAccountInfo() {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var AccountId;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            AccountId = getState().margin.accountInfo.AccountId;
            dispatch(getMarginAccountInfo(AccountId));
            dispatch(getAccountMarginBalances(AccountId));
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getMarginAccountInfo = exports.getMarginAccountInfo = function getMarginAccountInfo(AccountId) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      var OMSId, responseObj, _t4;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            if (OMSId) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            _context5.p = 1;
            _context5.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetMarginAccountInfo', {
              OMSId: OMSId,
              AccountId: AccountId
            }));
          case 2:
            responseObj = _context5.v;
            if (!(responseObj && responseObj.result !== false)) {
              _context5.n = 3;
              break;
            }
            dispatch(receiveMarginAccountInfo(responseObj));
            return _context5.a(2, true);
          case 3:
            console.error('getMarginAccountInfoError error: ', responseObj);
            return _context5.a(2, false);
          case 4:
            _context5.n = 6;
            break;
          case 5:
            _context5.p = 5;
            _t4 = _context5.v;
            console.error('getMarginAccountInfoError error: ', _t4);
            return _context5.a(2, false);
          case 6:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 5]]);
    }));
    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var receiveMarginAccountInfo = exports.receiveMarginAccountInfo = function receiveMarginAccountInfo(accountInfo) {
  return {
    type: _actionTypes.RECEIVE_MARGIN_ACCOUNT_INFO,
    payload: accountInfo
  };
};
var marginCallNotificationId = 'MarginCall';
var marginCallStatus = {
  OPEN: 'Open'
};
var subscribeMarginCallEvents = exports.subscribeMarginCallEvents = function subscribeMarginCallEvents(AccountId) {
  return function (dispatch) {
    _MarginCallSubscriptionService["default"].subscribe(function (payload) {
      if (payload.AccountId === AccountId) {
        if (payload.MarginCallStatus === marginCallStatus.OPEN) {
          dispatch((0, _snackbarActions.showSnack)({
            id: marginCallNotificationId,
            text: 'Margin account at risk. Your maintenance margin threshold has been reached',
            textVars: {
              ns: 'margin'
            },
            type: 'warning'
          }));
          dispatch((0, _marginNavNotificationActions.addMarginNavNotification)());
        }
      }
    });
  };
};
var subscribeMarginAccountBalanceSummaryStateEvents = exports.subscribeMarginAccountBalanceSummaryStateEvents = function subscribeMarginAccountBalanceSummaryStateEvents(AccountId) {
  return function (dispatch) {
    _MarginAccountBalanceSummaryStateSubscriptionService["default"].subscribe(function (payload) {
      if (payload.AccountId === AccountId) {
        dispatch(receiveMarginAccountInfo(payload));
      }
    });
  };
};
var subscribeMarginAccountBalanceStateEvents = exports.subscribeMarginAccountBalanceStateEvents = function subscribeMarginAccountBalanceStateEvents(AccountId) {
  return function (dispatch) {
    _MarginAccountBalanceStateSubscriptionService["default"].subscribe(function (payload) {
      var _payload$;
      if (((_payload$ = payload[0]) === null || _payload$ === void 0 ? void 0 : _payload$.AccountId) === AccountId) {
        dispatch({
          type: _actionTypes.UPDATE_MARGIN_BALANCES,
          payload: payload
        });
      }
    });
  };
};
var marginLiquidationNotificationIdBase = 'MarginPositionLiquidation';
var marginLiquidationStatus = {
  NEW: 'New'
};
var subscribeMarginLiquidationEvents = exports.subscribeMarginLiquidationEvents = function subscribeMarginLiquidationEvents(AccountId) {
  return function (dispatch, getState) {
    _MarginAccountLiquidationSubscriptionService["default"].subscribe(function (payload) {
      if (payload.AccountId === AccountId) {
        var _getState$apexCore$in;
        var instrumentSymbol = (_getState$apexCore$in = getState().apexCore.instrument.instruments.find(function (i) {
          return i.InstrumentId === payload.InstrumentId;
        })) === null || _getState$apexCore$in === void 0 ? void 0 : _getState$apexCore$in.Symbol;
        if (payload.LiquidationStage === marginLiquidationStatus.NEW) {
          dispatch((0, _snackbarActions.showSnack)({
            id: marginLiquidationNotificationIdBase,
            text: 'Your {{symbol}} {{positionType}} position has been liquidated.',
            textVars: {
              ns: 'margin',
              symbol: instrumentSymbol,
              positionType: payload.MarginPositionType,
              PositionId: payload.PositionId
            },
            type: 'warning'
          }));
          dispatch((0, _marginNavNotificationActions.addMarginNavNotification)());
        }
      }
    });
  };
};
var receiveMarginKVPInfo = exports.receiveMarginKVPInfo = function receiveMarginKVPInfo(marginKVPInfo) {
  return {
    type: _actionTypes.RECEIVE_MARGIN_KVP_INFO,
    payload: marginKVPInfo
  };
};
var getMarginKVP = exports.getMarginKVP = function getMarginKVP() {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch) {
      var marginVL, minDepositValue, payload, _t5;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            _context6.p = 0;
            _context6.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetGeneralKVP', {
              Key: 'MarginVerificationLevels'
            }));
          case 1:
            marginVL = _context6.v;
            _context6.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetGeneralKVP', {
              Key: 'MarginMinimumAccountValue'
            }));
          case 2:
            minDepositValue = _context6.v;
            payload = {
              marginVerificationLevels: marginVL.Value || '',
              minDepositValue: minDepositValue.Value || 0
            };
            dispatch(receiveMarginKVPInfo(payload));
            _context6.n = 4;
            break;
          case 3:
            _context6.p = 3;
            _t5 = _context6.v;
            console.error('getMarginKVP error: ', _t5);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'getMarginKVPError',
              text: _t5.o,
              type: 'warning'
            }));
          case 4:
            return _context6.a(2);
        }
      }, _callee6, null, [[0, 3]]);
    }));
    return function (_x0) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var receiveSystemMarginEnabled = exports.receiveSystemMarginEnabled = function receiveSystemMarginEnabled(systemMarginEnabled) {
  return {
    type: _actionTypes.RECEIVE_SYSTEM_MARGIN_ENABLED,
    payload: {
      systemMarginEnabled: systemMarginEnabled
    }
  };
};
var initMarginTrading = exports.initMarginTrading = function initMarginTrading(systemMarginEnabled) {
  return function (dispatch) {
    dispatch(receiveSystemMarginEnabled(systemMarginEnabled));
    dispatch(getMarginKVP());
  };
};
var getMarginProductsConfig = exports.getMarginProductsConfig = function getMarginProductsConfig() {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(dispatch, getState) {
      var OMSId, res, _t6;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            _context7.p = 1;
            _context7.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetAllMarginProductConfigs', {
              OMSId: OMSId
            }));
          case 2:
            res = _context7.v;
            dispatch({
              type: _actionTypes.RECEIVE_MARGIN_PRODUCT_CONFIGS,
              payload: res
            });
            _context7.n = 4;
            break;
          case 3:
            _context7.p = 3;
            _t6 = _context7.v;
            console.error('GetMarginProductsConfig error: ', _t6);
          case 4:
            return _context7.a(2);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref7.apply(this, arguments);
    };
  }();
};

/**
 * Loads the MaxAmount available to tranfer from the margin acccount.
 *
 * @param {number} productId Product ID to get the MaxTransferAmount for.
 * @returns {Promise<{ MaxAmount: number; IndexPrice: number }>}
 */
var getMaxTransferAmount = exports.getMaxTransferAmount = function getMaxTransferAmount(productId) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(dispatch, getState) {
      var OMSId, marginAccount, res, _t7;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            marginAccount = (0, _selectors.marginAccountSelector)(getState());
            if (!marginAccount) {
              _context8.n = 4;
              break;
            }
            _context8.p = 1;
            _context8.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetMaxTransferAmount', {
              OMSId: OMSId,
              AccountId: marginAccount.AccountId,
              ProductId: productId
            }));
          case 2:
            res = _context8.v;
            dispatch({
              type: _actionTypes.RECEIVE_MAX_TRANSFER_AMOUNT,
              payload: _objectSpread({
                productId: productId
              }, res)
            });
            return _context8.a(2, res);
          case 3:
            _context8.p = 3;
            _t7 = _context8.v;
            console.error('GetMaxTransferAmount error: ', _t7);
          case 4:
            return _context8.a(2);
        }
      }, _callee8, null, [[1, 3]]);
    }));
    return function (_x11, _x12) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var dismissMarginNotification = exports.dismissMarginNotification = function dismissMarginNotification(id) {
  return function (dispatch, getState) {
    try {
      var _getState$user;
      var userId = (_getState$user = getState().user) === null || _getState$user === void 0 || (_getState$user = _getState$user.userInfo) === null || _getState$user === void 0 ? void 0 : _getState$user.UserId;
      if (userId) {
        var marginNotifications = (0, _marginNotificationsReducer.getUserMarginNotifications)(userId);
        var updatedNotifications = marginNotifications.filter(function (notification) {
          return notification.id !== id;
        });
        (0, _marginNotificationsReducer.setUserMarginNotifications)(userId, updatedNotifications);
      }
    } catch (error) {
      console.error('DismissMarginNotification error', error);
    }
    return dispatch({
      type: _actionTypes.DISMISS_MARGIN_NOTIFICATION,
      payload: id
    });
  };
};
var getInstrumentVerificationLevelConfig = exports.getInstrumentVerificationLevelConfig = function getInstrumentVerificationLevelConfig(OMSId, AccountId) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(dispatch) {
      var response, config, _t8;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            _context9.p = 0;
            dispatch({
              type: _actionTypes.REQUEST_INSTRUMENT_VERIFICATION_LEVEL_CONFIGS
            });
            _context9.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetInstrumentVerificationLevelConfig', {
              OMSId: OMSId,
              AccountId: AccountId
            }));
          case 1:
            response = _context9.v;
            config = typeof response === 'string' ? JSON.parse(response) : response;
            dispatch({
              type: _actionTypes.RECEIVE_INSTRUMENT_VERIFICATION_LEVEL_CONFIGS,
              payload: config
            });
            _context9.n = 3;
            break;
          case 2:
            _context9.p = 2;
            _t8 = _context9.v;
            console.error('GetInstrumentVerificationLevelConfig error: ', _t8);
          case 3:
            return _context9.a(2);
        }
      }, _callee9, null, [[0, 2]]);
    }));
    return function (_x13) {
      return _ref9.apply(this, arguments);
    };
  }();
};